import React from 'react';
import { Section } from '../global';
import { useI18n } from '@whizz/react-i18n';
import Button from '../components/button/Button';
import { useLocalStorage } from 'react-use';
import { ADMIN_BEARER_NAME } from '../util/vars';

export default function AdminDashboardLayout({
  title,
  isLoading = false,

  children,
}: Props) {
  const { translate: t } = useI18n();
  const [ , , removeAdminBearer ] = useLocalStorage<string | null>(ADMIN_BEARER_NAME, null, { raw: true });

  return (
    <div className={'relative flex flex-col justify-between w-full'}>
      {title && (
        <div className={'flex justify-between w-full p-4 bg-white'}>
          <div />
          <div className={'p-1 border-b-4 border-header'}>
            <b className={'text-xl md:text-2xl'}>
              {title}
            </b>
          </div>
          <div>
            <Button
              asLink
              onClick={() => {
                removeAdminBearer();

                // history.push() doesn't work, so we will reload and Router will redirect to login
                window.location.reload();
              }}
            >
              {t('global.ROUTES.LOGOUT')}
            </Button>
          </div>
        </div>
      )}
      <div className={'flex flex-col justify-center w-full'}>
        <div className={'w-full mx-auto px-md'}>
          <div className={'container mt-8 pt-0'}>
            {!isLoading && (
              <Section>
                <div className={'container'}>
                  {children}
                </div>
              </Section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


interface Props {
  title?: string;
  isLoading?: boolean;
  fullWidthContent?: boolean;
  children: React.ReactNode;
}
